import React, { useContext, useState } from 'react';
import { PortContext } from '../service/MessageChannelContext';
import { ImageList } from '../components/micro/ImageList/ImageList';
import { TabSelector } from '../components/micro/TabSelector/TabSelector';
import RoughTextureImage from '../images/rough-texture.png';
import AcnePimplesImage from '../images/acne-pimples.png';
import EnlargedPoresImage from '../images/enlarged-pores.png';
import DrySkinImage from '../images/dry-skin.png';
import WhiteheadsBlackheadsImage from '../images/whitehead-blackhead.png';
import DullSkinImage from '../images/dull-skin.png';
import RednessImage from '../images/redness.png';
import DarkSpotsPigmentationImage from '../images/darkspot-pigmentation.png';
import OilySkinImage from '../images/oily.png';
import MorningRoutineImage from '../images/morning-routine.png';
import NightRoutineImage from '../images/night-routine.png';
import OtherProductsImage from '../images/other-products.png';
import DoImage from '../images/do.png';
import DontImage from '../images/dont.png';

import './ProductRecommendation.scss';
import { CardGrid } from '../components/micro/CardGrid/CardGrid';
import { Card } from '../components/micro/Card/Card';
import { Button } from '../components/micro/Button/Button';
import { useNavigate } from 'react-router-dom';

const content = {
  title: {
    en: 'Your Personalised Product Recommendations',
    id: 'Rekomendasi Produk Spesial Untukmu',
  },
  roughTexture: { en: 'Rough Texture', id: 'Kulit Kasar' },
  acnePimples: { en: 'Acne & Pimples', id: 'Acne & Pimples' },
  enlargedPores: { en: 'Enlarged Pores', id: 'Pori-pori Besar' },
  drySkin: { en: 'Dry Skin', id: 'Kulit Kering' },
  whiteheadsBlackheads: { en: 'Whiteheads & Blackheads', id: 'Whiteheads & Blackheads' },
  dullSkin: { en: 'Dull Skin', id: 'Kulit Kusam' },
  redness: { en: 'Redness', id: 'Kulit Kemerahan' },
  darkSpotsPigmentation: { en: 'Dark Spots & Pigmentation', id: 'Dark Spots & Pigmentation' },
  oilySkin: { en: 'Oily Skin', id: 'Kulit Berminyak' },
  morningRoutine: { en: 'Morning Routine', id: 'Rutinitas Pagi' },
  nightRoutine: { en: 'Night Routine', id: 'Rutinitas Malam' },
  other: { en: 'Other Products', id: 'Produk Lainnya' },
  addToCart: { en: 'Add to Cart', id: 'Tambah ke Keranjang' },
  backToSkinReport: { en: 'Back to Skin Report', id: 'Kembali ke Laporan Kulit' },
};

const skinIssueImages = {
  roughTexture: RoughTextureImage,
  acnePimples: AcnePimplesImage,
  enlargedPores: EnlargedPoresImage,
  drySkin: DrySkinImage,
  whiteheadsBlackheads: WhiteheadsBlackheadsImage,
  dullSkin: DullSkinImage,
  redness: RednessImage,
  darkSpotsPigmentation: DarkSpotsPigmentationImage,
  oilySkin: OilySkinImage,
};

const dos = {
  acne: [
    {
      en: 'Do Cleanse Gently: Use a mild, non-comedogenic cleanser twice daily to remove dirt and oil without over-drying your skin.',
      id: 'Bersihkan Wajah dengan Lembut: Gunakan pembersih yang ringan dan tidak menyumbat pori-pori dua kali sehari untuk menghilangkan kotoran dan minyak tanpa membuat kulitmu terlalu kering.',
    },
    {
      en: 'Do Use Salicylic Acid: Incorporate a product with salicylic acid to help unclog pores and reduce acne.',
      id: 'Gunakan Salicylic Acid/Asam Salisilat: Sertakan produk yang mengandung salicylic acid untuk membersihkan pori-pori dan mengurangi jerawat.',
    },
    {
      en: 'Do Moisturize: Use an oil-free, non-comedogenic moisturizer to keep your skin hydrated without clogging pores.',
      id: 'Gunakan Pelembap: Pakai moisturizer bebas minyak yang tidak menyumbat pori-pori untuk menjaga kelembapan kulitmu tanpa menyumat pori-pori.',
    },
    {
      en: 'Do Apply Sunscreen: Use a broad-spectrum sunscreen daily to protect your skin from UV damage and prevent post-acne dark spots.',
      id: 'Gunakan Sunscreen: Pakai sunscreen dengan broad spectrum setiap hari agar kulitmu terhindar dari kerusakan sinar UV dan timbulnya bintik hitam akibat jerawat.',
    },
    {
      en: 'Do Pat Dry: After washing your face, gently pat it dry with a clean, soft towel rather than rubbing.',
      id: 'Tepuk dan Keringkan Wajah: Setelah mencuci wajah, tepuk-tepuk pelan dengan handuk yang bersih dan halus hingga kering serta hindari menggosok wajahmu.',
    },
    {
      en: 'Do Exfoliate: Exfoliate 1-2 times a week with a gentle exfoliant to remove dead skin cells and prevent pore blockages.',
      id: 'Lakukan Eksfoliasi: Eksfoliasi 1-2 kali dalam seminggu dengan eksfoliator yang lembut untuk mengangkat sel-sel kulit mati dan mencegah penyumbatan pori-pori.',
    },
    {
      en: 'Do Keep Hair Clean: If you have long hair, keep it clean and away from your face, as hair products and oils can worsen acne.',
      id: 'Pastikan Rambutmu Bersih: Kalau kamu berambut panjang, jaga kebersihannya dan jauhkan dari wajahmu, karena produk serta minyak di rambutmu dapat memperburuk jerawatmu.',
    },
    {
      en: 'Do Wash Pillowcases: Change your pillowcases regularly to avoid transferring oils and bacteria to your face while you sleep.',
      id: 'Cuci Sarung Bantalmu: Ganti sarung bantalmu secara berkala untuk menghindari transfer minyak dan bakteri ke wajah saat kamu tidur. ',
    },
    {
      en: 'Do Hydrate: Drink plenty of water to keep your skin hydrated from within.',
      id: 'Tetap Terhidrasi: Minum banyak air putih supaya kulitmu tetap terjaga kelembapannya dari dalam.',
    },
    {
      en: 'Do Stress Management: Practice stress-reduction techniques like yoga or meditation, as stress can exacerbate acne.',
      id: 'Hindari Stres: Lakukan hal yang bisa mengurangi tingkat stresmu seperti yoga atau meditasi, karena stres bisa jadi pemicu jerawat.',
    },
    {
      en: "Do Consult a Dermatologist: If over-the-counter products aren't effective, consult a dermatologist for tailored treatment options.",
      id: 'Konsultasi dengan Dermatologis: Kalau obat yang dijual bebas tidak efektif, lakukan konsultasi dengan dermatologis untuk pilihan pengobatan yang sesuai kebutuhanmu.',
    },
    {
      en: 'Do Use Non-Comedogenic Makeup: Choose makeup labeled "non-comedogenic" to avoid pore-clogging.',
      id: 'Gunakan Makeup Non-Comedogenic: Pilih makeup berlabel "non-comedogenic" untuk menghindari penyumbatan pori-pori.',
    },
    {
      en: 'Do Test Products: Introduce new skincare products one at a time to identify any potential triggers.',
      id: 'Tes Produknya Dulu: Gunakan produk skincare yang baru kamu pakai secara bergantian, biar kamu tahu kalau ada yang tidak cocok denganmu.',
    },
    {
      en: 'Do Eat a Balanced Diet: Consume a diet rich in fruits, vegetables, and lean proteins, as good nutrition can support healthy skin.',
      id: 'Pastikan Gizimu Seimbang: Konsumsi makanan yang kaya akan buah, sayur, serta protein tanpa lemak karena nutrisi yang baik itu penting untuk kulit yang sehat.',
    },
    {
      en: 'Do Get Adequate Sleep: Aim for 7-9 hours of quality sleep each night to promote skin healing.',
      id: 'Tidur yang Cukup: Usahakan tidur 7-9 jam setiap malam untuk pemulihan kulit yang maksimal.',
    },
  ],
  texture: [
    {
      en: 'Do Exfoliate Gently: Use a mild exfoliator 1-2 times a week to remove dead skin cells and improve skin texture.',
      id: 'Lakukan Eksfoliasi dengan Lembut: Gunakan eksfoliator yang ringan 1-2 kali seminggu untuk mengangkat sel kulit mati dan memperbaiki tekstur kulitmu.',
    },
    {
      en: 'Do Hydrate: Use a moisturizer with hyaluronic acid to keep your skin hydrated and plump.',
      id: 'Tetap Terhidrasi: Gunakan pelembap dengan hyaluronic acid agar kulitmu tetap terhidrasi dan kenyal.',
    },
    {
      en: 'Do Use Vitamin C: Incorporate a vitamin C serum into your routine to promote collagen production and improve skin texture.',
      id: 'Gunakan Vitamin C: Sertakan serum vitamin C ke dalam rutinitasmu untuk membantu produksi kolagen dan memperbaiki tekstur kulitmu.',
    },
    {
      en: 'Do Apply Sunscreen: Protect your skin from UV damage with a broad-spectrum sunscreen to prevent further texture issues.',
      id: 'Gunakan Sunscreen: Lindungi kulitmu dari kerusakan sinar UV dengan sunscreen broad spectrum yang mencegah masalah tekstur kulit lainnya.',
    },
    {
      en: 'Do Use Retinoids: Consider using a retinoid product to stimulate skin cell turnover and improve texture over time.',
      id: 'Gunakan Retinoid: Pertimbangkan penggunaan produk retinoid untuk merangsang pergantian sel kulit dan memperbaiki tekstur kulit dari waktu ke waktu.',
    },
    {
      en: 'Do Maintain a Consistent Routine: Stick to a skincare routine and give products time to work before expecting visible improvements.',
      id: 'Lakukan Rutinitas yang Konsisten: Lakukan terus skinscare routine-mu dan biarkan produk bekerja sebelum berharap pada perubahan yang mulai terlihat.',
    },
    {
      en: 'Do Eat Antioxidant-Rich Foods: Consume foods high in antioxidants like berries, leafy greens, and nuts to support skin health.',
      id: 'Konsumsi Makanan Kaya Antioksidan: Asupan gizi yang kaya antioksidan seperti beragam buah beri, sayuran hijau, serta kacang dapat membantu kesehatan kulit.',
    },
    {
      en: 'Do Stay Hydrated: Drink enough water to maintain skin hydration from within.',
      id: 'Tetap Terhidrasi: Minum air putih secukupnya untuk menjaga kulit tetap terhidrasi dari dalam.',
    },
    {
      en: 'Do Consider Chemical Peels: Consult a dermatologist for chemical peel options to address texture issues.',
      id: 'Pertimbangkan Chemical Peels: Lakukan konsultasi dengan dermatologis jika kamu ingin melakukan chemical peels untuk mengatasi masalah tekstur kulit.',
    },
    {
      en: 'Do Use a Humidifier: In dry climates, use a humidifier to add moisture to the air, which can benefit your skin.',
      id: 'Gunakan Humidifier: Di iklim tropis, humidifier dapat menambah kelembapan udara yang bisa bermanfaat untuk kulitmu.',
    },
    {
      en: 'Do Seek Professional Advice: If your skin texture concerns are severe, consult a dermatologist for personalized treatment recommendations.',
      id: 'Cari Nasihat Profesional: Jika tekstur kulitmu sudah parah, konsultasikan dengan dermatologis untuk opsi perawatan yang sesuai kebutuhanmu.',
    },
    {
      en: 'Do Pat Dry: After cleansing, pat your face dry gently with a clean towel to avoid irritation.',
      id: 'Tepuk dan Keringkan Wajah: Setelah mencuci wajah, tepuk pelan wajahmu hingga kering dengan handuk bersih untuk menghindari iritasi.',
    },
    {
      en: 'Do Use a Silk Pillowcase: Silk pillowcases can reduce friction and help prevent rough skin.',
      id: 'Gunakan Sarung Bantal Sutra: Sarung bantal sutra bisa mengurangi gesekan dan membantu mencegah tekstur kulit yang kasar.',
    },
    {
      en: 'Do Massage Your Face: Gently massaging your face can improve blood circulation and contribute to smoother skin.',
      id: 'Pijat Wajahmu: Memijat wajah dengan lembut bisa meningkatkan sirkulasi darah dan membantu kulit agar semakin halus.',
    },
    {
      en: 'Do Prioritize Sleep: Aim for 7-9 hours of quality sleep each night to support skin regeneration.',
      id: 'Tidur yang Cukup: Usahakan tidur 7-9 jam setiap malam untuk membantu regenerasi kulit.',
    },
  ],
  poreSize: [
    {
      en: 'Do Use a Mild Cleanser: Use a gentle, non-comedogenic cleanser to keep pores clear without over-drying your skin.',
      id: 'Gunakan Cleanser yang Ringan: Pakai cleanser yang ringan dan tidak menyumbat pori-pori agar pori-porimu tetap bersih tanpa membuat kulitmu terlalu kering.',
    },
    {
      en: 'Do Exfoliate Regularly: Use a chemical exfoliant (e.g., salicylic acid or glycolic acid) to help remove debris from pores and improve their appearance.',
      id: 'Lakukan Eksfoliasi Teratur: Gunakan eksfolian kimia (seperti salicylic acid atau glycolic acid) untuk membantu mengangkat kotoran dari pori-pori dan memperbaiki penampilan pori-porimu.',
    },
    {
      en: 'Do Use Retinoids: Incorporate a retinoid product into your routine to promote skin cell turnover and minimize the appearance of pores.',
      id: 'Gunakan Retinoid: Sertakan produk retinoid ke dalam rutinitasmu untuk merangsang pergantian sel kulit dan meminimalisir pori-pori yang terlihat.',
    },
    {
      en: 'Do Apply Sunscreen: Protect your skin from UV damage with a broad-spectrum sunscreen to prevent enlarged pores caused by sun exposure.',
      id: 'Gunakan Sunscreen: Lindungi kulitmu dari kerusakan sinar UV dengan sunscreen broad spectrum yang mencegah pembesaran pori-pori dari paparan sinar matahari.',
    },
    {
      en: 'Do Keep Skin Hydrated: Use a lightweight, non-comedogenic moisturizer to keep your skin hydrated.',
      id: 'Kulit Selalu Terhidrasi: Gunakan pelembap yang ringan dan tidak menyumbat pori-pori agar kulitmu tetap terhidrasi.',
    },
    {
      en: 'Do Use a Clay Mask: Weekly use of a clay mask can help draw out impurities and temporarily tighten pores.',
      id: 'Gunakan Clay Mask: Penggunaan clay mask per minggu dapat membantu mengangkat kotoran dan mengencangkan pori-pori secara sementara.',
    },
    {
      en: 'Do Maintain a Consistent Routine: Stick to your skincare routine and be patient, as it can take time to see improvements in pore size.',
      id: 'Lakukan Rutinitas yang Konsisten: Lakukan terus skinscare routine-mu dan bersabarlah, karena dibutuhkan waktu untuk melihat perubahan pada ukuran pori-pori.',
    },
    {
      en: 'Do Stay Hydrated: Drinking plenty of water helps maintain skin elasticity and can improve pore appearance.',
      id: 'Tetap Terhidrasi: Minum air putih sebanyak mungkin membantu menjaga kekenyalan kulit dan meningkatkan penampilan pori-pori.',
    },
    {
      en: 'Do Use a Primer: Apply a makeup primer before foundation to create a smoother canvas and minimize pore visibility.',
      id: 'Gunakan Primer: Gunakan primer makeup sebelum foundation untuk permukaan kulit yang lebih halus dan meminimalisir tampilan pori-pori.',
    },
    {
      en: 'Do Remove Makeup Before Bed: Always remove makeup before bedtime to prevent clogged pores.',
      id: 'Hapus Makeup Sebelum Tidur: Selalu hapus makeup sebelum tidur untuk mencegah penyumbatan pori-pori.',
    },
    {
      en: 'Do Steam Your Face: Occasional facial steaming can help loosen debris in pores, making them easier to cleanse.',
      id: 'Lakukan Steam Wajah: Steam wajah sesekali dapat membantu melonggarkan kotoran di pori-pori, sehingga lebih mudah dibersihkan.',
    },
    {
      en: 'Do Choose Oil-Free Products: Use oil-free and non-comedogenic skincare and makeup products to avoid pore blockage.',
      id: 'Pilih Produk yang Bebas Minyak: Gunakan produk skincare dan makeup yang bebas minyak serta tidak menyumbat pori-pori agar pori-porimu tetap terjaga.',
    },
    {
      en: 'Do Blot Excess Oil: Use oil-absorbing sheets or blotting papers throughout the day to manage excess oil on the skin.',
      id: 'Atasi Minyak Berlebih: Gunakan kertas minyak sepanjang hari untuk mengantisipasi kelebihan minyak di kulit wajah.',
    },
    {
      en: 'Do Use Ice Cubes: Gently rub an ice cube wrapped in a soft cloth over your face to temporarily shrink pores.',
      id: 'Gunakan Es Batu: Gosok es batu yang telah dibungkus kain lembut ke seluruh wajah untuk mengecilkan ukuran pori-pori secara sementara.',
    },
    {
      en: 'Do Consult a Dermatologist: Seek professional advice for treatments like chemical peels or laser therapy to address pore size.',
      id: 'Konsultasi dengan Dermatologis: Cari nasihat profesional untuk perawatan seperti chemical peels atau terapi laser untuk mengatasi ukuran pori-pori.',
    },
  ],
  darkSpots: [
    {
      en: 'Do Apply Sunscreen: Use a broad-spectrum sunscreen with SPF 30 or higher daily to prevent further darkening of spots caused by UV exposure.',
      id: 'Gunakan Sunscreen: Pakai sunscreen broad spectrum dengan SPF 30 atau lebih setiap hari untuk mencegah penggelapan bintik hitam yang diakibatkan dari paparan sinar UV.',
    },
    {
      en: 'Do Use Vitamin C: Incorporate a vitamin C serum into your routine to help fade dark spots and brighten your complexion.',
      id: 'Gunakan Vitamin C: Sertakan serum vitamin C ke dalam rutinitasmu untuk membantu menghilangkan bintik hitam dan mencerahkan kulitmu.',
    },
    {
      en: "Do Use Sun Protection Gear: Wear wide-brimmed hats and sunglasses to shield your face from the sun's harmful rays.",
      id: 'Gunakan Pelindung Matahari: Pakai topi dengan pinggiran lebar dan sunglasses untuk melindungi wajahmu dari kerusakan sinar matahari.',
    },
    {
      en: 'Do Exfoliate Gently: Use a mild chemical exfoliant (e.g., alpha hydroxy acids or AHAs) to promote skin cell turnover and reduce dark spots.',
      id: 'Lakukan Eksfoliasi dengan Lembut: Gunakan eksfolian kimia (seperti alpha hydroxy acids atau AHA) untuk membantu pergantian sel kulit dan mengurangi bintik hitam.',
    },
    {
      en: 'Do Use Skin-Lightening Ingredients: Look for products containing ingredients like niacinamide, licorice root extract, and kojic acid to target dark spots.',
      id: 'Gunakan Bahan yang Mencerahkan Kulit: Cari produk yang mengandung bahan seperti niacinamide, ekstrak akar manis, serta kojic acid untuk mengatasi bintik hitam.',
    },
    {
      en: 'Do Stay Hydrated: Drink plenty of water to keep your skin hydrated, which can improve overall skin health.',
      id: 'Tetap Terhidrasi: Minum air putih sebanyak mungkin untuk menjaga kulit agar tetap terhidrasi, yang bisa meningkatkan kesehatan kulit secara menyeluruh.',
    },
    {
      en: 'Do Use Brightening Masks: Consider using masks with ingredients like papaya or turmeric for added skin brightening benefits.',
      id: 'Gunakan Brightening Mask: Pertimbangkan penggunaan masker dengan bahan seperti pepaya atau kunyit yang membuat wajah menjadi cerah.',
    },
    {
      en: 'Do Use Brightening Masks: Consider using masks with ingredients like papaya or turmeric for added skin brightening benefits.',
      id: 'Gunakan Brightening Mask: Pertimbangkan penggunaan masker dengan bahan seperti pepaya atau kunyit yang membuat wajah menjadi cerah.',
    },
    {
      en: 'Do Eat Antioxidant-Rich Foods: A diet rich in antioxidants can support skin health and reduce the appearance of dark spots.',
      id: 'Konsumsi Makanan Kaya Antioksidan: Asupan gizi yang kaya antioksidan dapat membantu kesehatan kulit dan mengurangi kemunculan bintik hitam.',
    },
    {
      en: 'Do Use Retinoids: Consult a dermatologist about incorporating retinoid products into your routine for skin renewal.',
      id: 'Gunakan Retinoid: Konsultasikan dengan dermatologis tentang penggunaan produk retinoid yang membantu regenerasi kulit ke dalam rutinitasmu.',
    },
    {
      en: 'Do Pat Your Skin Dry: After cleansing your face, gently pat it dry with a clean towel to avoid irritation.',
      id: 'Tepuk dan Keringkan Wajah: Setelah mencuci wajah, tepuk pelan wajahmu hingga kering dengan handuk bersih untuk menghindari iritasi.',
    },
    {
      en: 'Do Stay Consistent: Consistency is key in treating dark spots. Stick to your skincare routine for best results.',
      id: 'Tetap Konsisten: Konsisten adalah kunci dalam penanganan bintik hitam. Lakukan terus skincare routine-mu untuk hasil terbaik.',
    },
    {
      en: 'Do Seek Professional Advice: If dark spots persist or worsen, consult a dermatologist for personalized treatment options.',
      id: 'Cari Nasihat Profesional: Jika bintik hitam tak kunjung hilang atau memburuk, konsultasikan dengan dermatologis untuk opsi perawatan yang sesuai kebutuhanmu.',
    },
    {
      en: 'Do Manage Skin Conditions: If you have conditions like acne, address them promptly to prevent post-inflammatory hyperpigmentation (dark spots).',
      id: 'Tangani Kondisi Kulitmu: Kalau kulitmu punya kondisi seperti jerawat, tangani secepatnya untuk mencegah hiperpigmentasi pasca-peradangan atau bintik hitam.',
    },
    {
      en: 'Do Use a Brightening Primer: Apply a brightening primer under makeup to minimize the appearance of dark spots.',
      id: 'Gunakan Brightening Primer: Pakai brightening primer sebelum makeup untuk meminimalisir kemunculan bintik hitam.',
    },
  ],
  brightness: [
    {
      en: 'Do Exfoliate: Regularly exfoliate with a gentle scrub or chemical exfoliant (e.g., alpha hydroxy acids or AHAs) to remove dead skin cells and reveal brighter skin.',
      id: 'Lakukan Eksfoliasi: Eksfoliasi secara teratur dengan scrub lembut atau eksfolian kimia (seperti alpha hydroxy acids atau AHA) untuk mengangkat sel-sel kulit mati dan membuat kulit lebih cerah.',
    },
    {
      en: 'Do Stay Hydrated: Drink an adequate amount of water to maintain skin hydration and a healthy glow.',
      id: 'Tetap Terhidrasi: Minum air putih secukupnya untuk menjaga kulit agar tetap terhidrasi dan bersinar sehat.',
    },
    {
      en: 'Do Use a Hydrating Moisturizer: Apply a hydrating moisturizer to keep your skin supple and radiant.',
      id: 'Gunakan Hydrating Moisturizer: Pakai hydrating moisturizer yang menjaga kekenyalan dan cerahnya kulitmu.',
    },
    {
      en: 'Do Use a Vitamin C Serum: Incorporate a vitamin C serum into your routine to brighten skin and even out skin tone.',
      id: 'Gunakan Serum Vitamin C: Sertakan serum vitamin C ke dalam rutinitasmu untuk mencerahkan dan meratakan warna kulitmu.',
    },
    {
      en: 'Do Eat a Balanced Diet: Consume a diet rich in fruits and vegetables for essential nutrients that support skin health.',
      id: 'Pastikan Gizimu Seimbang: Konsumsi makanan yang kaya akan buah dan sayur untuk nutrisi penting yang membantu kesehatan kulit.',
    },
    {
      en: 'Do Get Enough Sleep: Aim for 7-9 hours of quality sleep each night to allow your skin to repair and rejuvenate.',
      id: 'Tidur yang Cukup: Usahakan tidur 7-9 jam setiap malam untuk membantu kulitmu memperbaiki dan meremajakan diri.',
    },
    {
      en: 'Do Wear Sunscreen: Protect your skin from UV damage by using sunscreen daily to prevent premature aging and dullness.',
      id: 'Pakai Sunscreen: Lindungi kulit dari kerusakan sinar UV dengan penggunaan sunscreen setiap hari untuk mencegah penuaan dini dan kulit kusam.',
    },
    {
      en: 'Do Use a Skin Brightening Mask: Use masks with ingredients like papaya, glycolic acid, or turmeric for added brightness.',
      id: 'Gunakan Brightening Mask: Pakai masker dengan bahan seperti pepaya, glycolic acid, atau kunyit yang membuat wajah menjadi cerah.',
    },
    {
      en: 'Do Stay Active: Regular physical activity improves blood circulation, which can contribute to a healthy complexion.',
      id: 'Bergerak Aktif: Aktivitas fisik yang teratur meningkatkan sirkulasi darah, yang dapat membantu kesehatan kulit.',
    },
    {
      en: 'Do Apply a Primer: Use a makeup primer with light-reflecting properties to instantly boost skin radiance.',
      id: 'Gunakan Primer: Gunakan primer makeup yang dapat memantulkan cahaya agar kulit bisa lebih bersinar. ',
    },
    {
      en: 'Do Use a Humidifier: In dry climates, a humidifier can add moisture to the air, helping prevent skin dryness.',
      id: 'Gunakan Humidifier: Di iklim tropis, humidifier dapat menambah kelembapan udara yang dapat mencegah keringnya kulit wajahmu.',
    },
    {
      en: 'Do Practice Stress-Relief: Manage stress through techniques like meditation or yoga, as stress can dull the complexion.',
      id: 'Atasi Stres dengan Baik: Kelola stresmu dengan hal-hal seperti meditasi atau yoga, karena stres bisa membuat kulit menjadi kusam.',
    },
    {
      en: 'Do Use Illuminating Makeup: Choose makeup products with illuminating or highlighting properties for added radiance.',
      id: 'Gunakan Makeup yang Mencerahkan: Pilih produk makeup yang bisa mencerahkan agar kulitmu bisa lebih bersinar.',
    },
    {
      en: 'Do Double Cleanse: Remove makeup and cleanse your face thoroughly to prevent clogged pores and dullness.',
      id: 'Lakukan Double Cleanse: Hapus makeup dan cuci wajahmu secara menyeluruh untuk menghindari penyumbatan pori serta kulit kusam.',
    },
    {
      en: 'Do Incorporate Antioxidants: Use products with antioxidants like green tea extract to protect your skin from environmental damage.',
      id: 'Sertakan Produk Berantioksidan: Gunakan produk dengan antioksidan seperti ekstrak teh hijau untuk melindungi kulitmu dari kerusakan lingkungan.',
    },
  ],
};

const donts = {
  acne: [
    {
      en: "Don't Pop Pimples: Avoid picking, squeezing, or popping acne lesions, as it can lead to scarring and infection.",
      id: 'Jangan Pecahkan Jerawat: Hindari menekan, meremas, atau memecahkan jerawatmu, karena bisa menyebabkan luka dan infeksi.',
    },
    {
      en: "Don't Over-Cleanse: Washing your face excessively can strip away natural oils and worsen acne. Stick to a morning and evening routine.",
      id: 'Jangan Berlebihan Mencuci Wajah: Mencuci wajahmu secara berlebihan bisa mengurangi minyak alami di wajah dan memperparah jerawat. Hanya jalani rutinitas pagi dan malammu.',
    },
    {
      en: "Don't Use Harsh Scrubs: Avoid abrasive scrubs and harsh physical exfoliants, as they can irritate the skin.",
      id: 'Jangan Gunakan Scrub Kasar: Hindari scrub yang abrasif dan eksfoliator yang kasar, karena dapat membuat kulitmu iritasi.',
    },
    {
      en: "Don't Skip Sunscreen: Even if you have acne, skipping sunscreen can lead to more skin issues. Find a non-comedogenic sunscreen.",
      id: 'Jangan Skip Sunscreen: Biarpun lagi jerawatan, nggak pakai sunscreen bisa menyebabkan lebih banyak masalah kulit. Gunakan sunscreen yang tidak menyumbat pori-pori.',
    },
    {
      en: "Don't Use Heavy Products: Avoid heavy, greasy, or oil-based skincare and makeup products.",
      id: 'Jangan Gunakan Produk Berat: Hindari produk skincare dan makeup yang berat, berminyak, atau berbasis minyak.',
    },
    {
      en: "Don't Touch Your Face: Keep your hands off your face to prevent the transfer of bacteria and oils.",
      id: 'Jangan Sentuh Wajahmu: Jauhi tanganmu dari wajah untuk mencegah transfer bakteri dan minyak.',
    },
    {
      en: "Don't Share Makeup Brushes: Sharing brushes can introduce bacteria, leading to breakouts.",
      id: 'Jangan Berbagi Brush Makeup: Berbagi brush makeup bisa menularkan bakteri yang dapat menimbulkan jerawat.',
    },
    {
      en: "Don't Skip Moisturizer: Even if you have oily skin, skipping moisturizer can make your skin produce more oil.",
      id: 'Jangan Skip Pelembap: Biarpun kulitmu berminyak, nggak pakai pelembap bisa bikin kulitmu memproduksi lebih banyak minyak.',
    },
    {
      en: "Don't Use Tanning Beds: Exposure to UV radiation from tanning beds can worsen acne and increase the risk of skin cancer.",
      id: 'Jangan Gunakan Mesin Tanning: Paparan ke radiasi sinar UV bisa memperparah jerawatmu dan meningkatkan risikomu terkena kanker kulit.',
    },
    {
      en: "Don't Overdo Acne Treatments: Using too many acne products simultaneously can irritate your skin. Stick to a simplified routine.",
      id: 'Jangan Berlebihan dalam Perawatan Jerawat: Terlalu banyak menggunakan produk jerawat dalam waktu bersamaan dapat menimbulkan iritasi kulit. Hanya jalani rutinitas yang penting saja.',
    },
    {
      en: "Don't Use Hot Water: Avoid hot water when cleansing your face, as it can be drying and irritating.",
      id: 'Jangan Gunakan Air Panas: Hindari air panas untuk mencuci wajah, karena dapat membuat kulitmu kering dan iritasi.',
    },
    {
      en: "Don't Stress: High-stress levels can trigger acne flare-ups, so practice stress management techniques.",
      id: 'Hindari Stres: Tingkat stres yang tinggi bisa memicu jerawat, jadi lakukan hal-hal yang dapat mengurangi stresmu.',
    },
    {
      en: "Don't Use Dirty Phones and Glasses: Clean your phone and eyeglasses regularly to remove oils and bacteria.",
      id: 'Jaga Kebersihan HP dan Kaca Mata: Bersihkan HP dan kaca matamu secara berkala untuk mengangkat minyak dan bakteri.',
    },
    {
      en: "Don't Smoke: Smoking can worsen acne and decrease skin's ability to heal.",
      id: 'Jangan Merokok: Merokok dapat memperparah jerawat dan mengurangi kemampuan kulit untuk penyembuhan.',
    },
    {
      en: "Don't Discontinue Treatment Early: Be patient with acne treatments; they often take time to show results. Don't discontinue prematurely.",
      id: 'Jangan Hentikan Perawatan Terlalu Dini: Bersabarlah dengan pengobatan jerawat; karena hasil yang baik pasti membutuhkan waktu. Jangan hentikan pengobatan secara prematur.',
    },
  ],
  texture: [
    {
      en: "Don't Over-Exfoliate: Excessive exfoliation can irritate the skin and worsen texture issues. Stick to a moderate schedule.",
      id: 'Jangan Eskfoliasi Berlebih: Eksfoliasi yang terlalu sering bisa menimbulkan iritasi kulit dan memperparah masalah tekstur kulit. Ikuti jadwal eksfoliasi seperlunya.',
    },
    {
      en: "Don't Skip Moisturizer: Even if you have oily skin, skipping moisturizer can lead to dehydration and worsen texture problems.",
      id: 'Jangan Skip Pelembap: Biarpun kulitmu berminyak, nggak pakai pelembap bisa bikin kulitmu dehidrasi dan memperparah masalah tekstur kulitmu.',
    },
    {
      en: "Don't Use Harsh Cleansers: Avoid harsh cleansers that can strip natural oils and disrupt your skin's barrier.",
      id: 'Jangan Gunakan Harsh Cleanser: Hindari harsh cleanser yang bisa mengurangi minyak alami di wajah dan mengganggu skin barrier-mu',
    },
    {
      en: "Don't Pick at Skin: Avoid picking or scratching your skin, as it can lead to scarring and worsen texture.",
      id: 'Jangan Menekan Kulitmu: Hindari menekan dan menggaruk kulitmu, karena dapat menyebabkan luka dan memperparah tekstur kulitmu.',
    },
    {
      en: "Don't Use Hot Water: Hot water can be drying and irritating. Use lukewarm water for cleansing.",
      id: 'Jangan Gunakan Air Panas: Air panas bisa membuat kulitmu kering dan iritasi. Gunakan air hangat untuk membersihkan wajahmu.',
    },
    {
      en: "Don't Skip Sunscreen: UV damage can worsen skin texture and lead to premature aging.",
      id: 'Jangan Skip Sunscreen: Kerusakan sinar UV bisa memperparah tekstur kulit dan mengakibatkan penuaan dini.',
    },
    {
      en: "Don't Smoke: Smoking can accelerate skin aging and contribute to rough texture.",
      id: 'Jangan Merokok: Merokok dapat mempercepat penuaan kulit dan berkontribusi pada tekstur kulit yang kasar.',
    },
    {
      en: "Don't Use Heavy Makeup: Heavy makeup can clog pores and make skin texture appear worse.",
      id: 'Hindari Heavy Makeup: Heavy makeup bisa menyumbat pori-pori dan membuat tekstur kulit terlihat semakin buruk.',
    },
    {
      en: "Don't Use Bar Soaps: Bar soaps can be too harsh and drying for the face.",
      id: 'Jangan Gunakan Sabun Batang: Sabun batang bisa bersifat terlalu keras dan dapat membuat kulit wajahmu jadi kering.',
    },
    {
      en: "Don't Stress: High stress levels can exacerbate skin issues, including texture problems.",
      id: 'Hindari Stres: Tingkat stres yang tinggi dapat memperburuk masalah kulit, termasuk masalah tekstur.',
    },
    {
      en: "Don't Skip Professional Help: If at-home remedies aren't improving texture concerns, consult a dermatologist.",
      id: 'Jangan Skip Bantuan Profesional: Jika perawatan rumahan tidak kunjung memperbaiki masalah tekstur kulitmu, konsultasikan dengan dermatologis.',
    },
    {
      en: "Don't Overload on Products: Using too many products at once can overwhelm your skin and lead to issues.",
      id: 'Jangan Berlebihan Menggunakan Produk: Menggunakan produk terlalu banyak sekaligus dapat membebani kulitmu dan menimbulkan berbagai masalah kulit.',
    },
    {
      en: "Don't Ignore Diet: A balanced diet with vitamins and minerals can contribute to better skin texture.",
      id: 'Jangan Sepelekan Makananmu: Asupan gizi yang seimbang dengan vitamin dan mineral bisa membantu membuat tekstur kulitmu membaik.',
    },
    {
      en: "Don't Use Dirty Makeup Brushes: Regularly clean makeup brushes to prevent bacterial buildup on your skin.",
      id: 'Jangan Gunakan Brush Makeup Kotor: Bersihkan brush makeupmu untuk menghindari penumpukan bakteri pada kulitmu.',
    },
    {
      en: "Don't Discontinue Treatment Early: Be patient with skincare products; they often take time to show results. Don't give up too soon.",
      id: 'Jangan Hentikan Perawatan Terlalu Dini: Bersabarlah dengan produk skincare-mu; karena hasil yang baik pasti membutuhkan waktu. Jangan menyerah terlalu cepat, ya!',
    },
  ],
  poreSize: [
    {
      en: "Don't Use Harsh Scrubs: Avoid abrasive physical scrubs, as they can irritate and enlarge pores.",
      id: 'Jangan Gunakan Scrub Kasar: Hindari scrub fisik yang kasar, karena dapat membuat kulitmu iritasi dan memperbesar pori-porimu.',
    },
    {
      en: "Don't Over-Exfoliate: Excessive exfoliation can worsen pore size and irritate the skin.",
      id: 'Jangan Eskfoliasi Berlebih: Eksfoliasi yang terlalu sering bisa memperparah ukuran pori-pori dan membuat kulit iritasi.',
    },
    {
      en: "Don't Use Hot Water: Hot water can strip natural oils and potentially enlarge pores. Stick to lukewarm water for cleansing.",
      id: 'Jangan Gunakan Air Panas: Air panas bisa mengurangi minyak alami dan berpotensi memperbesar pori-pori. Gunakan air hangat untuk mencuci wajah.',
    },
    {
      en: "Don't Pick at Pores: Refrain from squeezing or picking at your pores, as it can lead to inflammation and scarring.",
      id: 'Jangan Menekan Pori-Pori: Hindari meremas atau menekan pori-porimu, karena dapat menyebabkan radang dan bekas luka.',
    },
    {
      en: "Don't Skip Sunscreen: UV damage can weaken collagen and elastin, making pores appear larger.",
      id: 'Jangan Skip Sunscreen: Kerusakan sinar UV bisa melemahkan kolagen dan elastin yang membuat pori-pori tampak lebih besar.',
    },
    {
      en: "Don't Use Heavy, Comedogenic Products: Avoid heavy makeup and skincare products that may clog pores.",
      id: 'Jangan Gunakan Produk yang Menyumbat Pori-Pori: Hindari heavy makeup dan produk skincare yang berpotensi menyumbat pori-pori.',
    },
    {
      en: "Don't Use Alcohol-Based Toners: Alcohol-based toners can be too harsh and drying for the skin.",
      id: 'Jangan Gunakan Toner Berbasis Alkohol: Toner berbasis alkohol dapat bersifat terlalu keras dan membuat kulitmu kering.',
    },
    {
      en: "Don't Smoke: Smoking can contribute to skin aging and worsen pore appearance.",
      id: 'Jangan Merokok: Merokok dapat menyebabkan penuaan kulit serta memperburuk penampilan pori-pori.',
    },
    {
      en: "Don't Stress: High stress levels can lead to increased oil production and worsen pore size.",
      id: 'Hindari Stres: Tingkat stres yang tinggi dapat meningkatkan produksi minyak dan memperparah ukuran pori-pori.',
    },
    {
      en: "Don't Overload on Products: Using too many products simultaneously can overwhelm your skin and exacerbate issues.",
      id: 'Jangan Berlebihan Menggunakan Produk: Menggunakan produk terlalu banyak sekaligus dapat membebani kulitmu dan memperburuk masalahmu.',
    },
    {
      en: "Don't Ignore Diet: A balanced diet with antioxidants can support skin health and minimize pore visibility.",
      id: 'Jangan Sepelekan Makananmu: Asupan gizi yang seimbang dengan antioksidan bisa membantu kesehatan kulitmu dan meminimalisir pori-pori yang terlihat.',
    },
    {
      en: "Don't Use Dirty Makeup Brushes: Regularly clean makeup brushes to prevent bacterial buildup on your skin.",
      id: 'Jangan Gunakan Brush Makeup Kotor: Bersihkan brush makeupmu untuk menghindari penumpukan bakteri pada kulitmu.',
    },
    {
      en: "Don't Discontinue Treatment Early: Be patient with skincare products; it may take time to see results. Don't give up too soon.",
      id: 'Jangan Hentikan Perawatan Terlalu Dini: Bersabarlah dengan produk skincare-mu; karena hasil yang baik pasti membutuhkan waktu. Jangan menyerah terlalu cepat, ya!',
    },
    {
      en: "Don't Use Heavy Oils: Avoid heavy facial oils, as they can contribute to pore blockage.",
      id: 'Jangan Gunakan Heavy Oils: Hindari produk facial oil yang berat, karena dapat menyumbat pori-pori.',
    },
    {
      en: "Don't Skip Professional Help: If your pore size concerns persist, consult a dermatologist for personalized advice and treatments.",
      id: 'Jangan Skip Bantuan Profesional: Jika masalah ukuran pori-porimu terus berlanjut, konsultasikan dengan dermatologis untuk saran dan pengobatan yang sesuai kebutuhanmu.',
    },
  ],
  darkSpots: [
    {
      en: "Don't Skip Sunscreen: Sun exposure can exacerbate dark spots and make them more noticeable. Always wear sunscreen.",
      id: 'Jangan Skip Sunscreen: Paparan sinar matahari bisa memperburuk bintik hitam dan membuatnya terlihat jelas. Selalu pakai sunscreen, ya!',
    },
    {
      en: "Don't Pick at Dark Spots: Picking or scratching dark spots can lead to scarring and worsen their appearance.",
      id: 'Jangan Menekan Bintik Hitam: Hindari menekan dan menggaruk bintik hitam karena dapat menyebabkan bekas luka dan memperparah penampilannya.',
    },
    {
      en: "Don't Over-Exfoliate: Excessive exfoliation can irritate your skin and make dark spots more prominent.",
      id: 'Jangan Eskfoliasi Berlebih: Eksfoliasi yang terlalu sering bisa menimbulkan iritasi kulit dan membuat bintik hitam semakin jelas terlihat.',
    },
    {
      en: "Don't Skip Moisturizer: A moisturizer helps maintain skin health and can improve the overall appearance of dark spots.",
      id: 'Jangan Skip Pelembap: Pelembap membantu menjaga kesehatan kulit dan dapat meningkatkan penampilan menyeluruh dari bintik hitam.',
    },
    {
      en: "Don't Use Hot Water: Hot water can dry out your skin and potentially worsen dark spots. Opt for lukewarm water for cleansing.",
      id: 'Jangan Gunakan Air Panas: Air panas bisa membuat kulitmu kering dan berpotensi memperburuk bintik hitam. Pilih air hangat untuk mencuci wajah.',
    },
    {
      en: "Don't Smoke: Smoking can accelerate skin aging and contribute to the formation of dark spots.",
      id: 'Jangan Merokok: Merokok dapat mempercepat penuaan kulit dan membantu terbentuknya bintik hitam.',
    },
    {
      en: "Don't Overload on Products: Using too many skincare products at once can irritate your skin and lead to more issues.",
      id: 'Jangan Berlebihan Menggunakan Produk: Menggunakan produk terlalu banyak sekaligus dapat membuat kulitmu iritasi dan menimbulkan berbagai masalah lainnya.',
    },
    {
      en: "Don't Ignore Diet: A balanced diet with plenty of fruits and vegetables can provide essential nutrients for skin health.",
      id: 'Jangan Sepelekan Makananmu: Asupan gizi yang seimbang dengan buah dan sayur dapat memberikan nutrisi penting untuk kesehatan kulit.',
    },
    {
      en: "Don't Use Heavy Makeup: Heavy makeup can clog pores and make dark spots appear more pronounced.",
      id: 'Hindari Heavy Makeup: Heavy makeup bisa menyumbat pori-pori dan membuat bintik hitam semakin terlihat.',
    },
    {
      en: "Don't Skip Professional Help: If over-the-counter products aren't effective, consult a dermatologist for advanced treatment options.",
      id: 'Jangan Skip Bantuan Profesional: Kalau obat yang dijual bebas tidak efektif, lakukan konsultasi dengan dermatologis untuk pilihan pengobatan yang sesuai kebutuhanmu.',
    },
    {
      en: "Don't Use Harsh Cleansers: Avoid harsh cleansers that can strip your skin's natural oils and cause irritation.",
      id: 'Jangan Gunakan Harsh Cleanser: Hindari harsh cleanser yang bisa mengurangi minyak alami di wajah dan menyebabkan iritasi.',
    },
    {
      en: "Don't Stress: High stress levels can contribute to skin issues, including the appearance of dark spots.",
      id: 'Hindari Stres: Tingkat stres yang tinggi dapat menimbulkan berbagai masalah kulit, termasuk kemunculan bintik hitam.',
    },
    {
      en: "Don't Discontinue Treatment Early: Be patient with skincare products; it may take several weeks to see improvements.",
      id: 'Jangan Hentikan Perawatan Terlalu Dini: Bersabarlah dengan produk skincare-mu; mungkin saja butuh waktu beberapa minggu untuk melihat perubahannya.',
    },
    {
      en: "Don't Skip Nighttime Routine: Apply dark spot treatments before bed to maximize their effectiveness.",
      id: 'Jangan Skip Rutinitas Malam: Gunakan perawatan bintik hitam sebelum tidur untuk memaksimalkan khasiatnya.',
    },
    {
      en: "Don't Use Lemon Juice: Avoid using lemon juice on your skin, as it can be too acidic and potentially harmful.",
      id: 'Jangan Gunakan Perasan Lemon: Hindari memakai air perasan lemon untuk kulitmu, karena terlalu asam dan berpotensi merusak kulitmu.',
    },
  ],
  brightness: [
    {
      en: "Don't Over-Exfoliate: Excessive exfoliation can damage the skin barrier and worsen dullness. Stick to a gentle exfoliation routine.",
      id: 'Jangan Eskfoliasi Berlebih: Eksfoliasi yang terlalu sering bisa merusak skin barrier dan memperparah kulit kusam. Ikuti rutinitas eksfoliasi yang lembut.',
    },
    {
      en: "Don't Skip Sunscreen: UV damage can lead to skin dullness and premature aging. Always apply sunscreen.",
      id: 'Jangan Skip Sunscreen: Kerusakan sinar UV bisa mengakibatkan kulit kusam dan penuaan dini. Pastikan kamu selalu pakai sunscreen, ya!',
    },
    {
      en: "Don't Smoke: Smoking can deplete oxygen in the skin, leading to a lackluster complexion.",
      id: 'Jangan Merokok: Merokok dapat mengurangi oksigen dalam kulit, yang mengakibatkan kulit kusam.',
    },
    {
      en: "Don't Use Harsh Cleansers: Avoid cleansers that strip your skin of natural oils, which can make it look dull.",
      id: 'Jangan Gunakan Harsh Cleanser: Hindari harsh cleanser yang bisa mengurangi minyak alami di wajah, yang dapat menyebabkan kulit tampak kusam.',
    },
    {
      en: "Don't Use Hot Water: Hot water can dehydrate the skin and contribute to dullness. Use lukewarm water for cleansing.",
      id: 'Jangan Gunakan Air Panas: Air panas bisa membuat kulitmu kering dan kusam. Gunakan air hangat untuk mencuci wajah.',
    },
    {
      en: "Don't Neglect Diet: An unhealthy diet can lead to skin issues. Consume foods rich in vitamins and minerals.",
      id: 'Jangan Sepelekan Makananmu: Makanan yang tidak sehat bisa menyebabkan masalah kulit. Konsumsilah makanan yang kaya akan vitamin dan mineral.',
    },
    {
      en: "Don't Discontinue Skincare Routine: Consistency is essential. Stick to your skincare routine for long-term results.",
      id: 'Jangan Hentikan Skincare Terlalu Dini: Konsistensi adalah kunci. Ikuti skincare routine-mu untuk dapatkan hasil jangka panjang.',
    },
    {
      en: "Don't Skip Makeup Removal: Leaving makeup on overnight can clog pores and make your skin look dull.",
      id: 'Jangan Skip Menghapus Makeup: Membiarkan makeup semalaman bisa menyumbat pori-pori dan membuat kulitmu tampak kusam.',
    },
    {
      en: "Don't Touch Your Face: Avoid touching your face with unwashed hands, as it can transfer dirt and bacteria.",
      id: 'Jangan Sentuh Wajahmu: Hindari memegang wajah dengan tangan yang belum dicuci, karena bisa membawa kotoran dan bakteri ke wajahmu.',
    },
    {
      en: "Don't Use Heavy Makeup: Heavy makeup can settle into fine lines and emphasize dullness.",
      id: 'Hindari Heavy Makeup: Heavy makeup bisa menyumbat garis-garis halus dan memperparah kulit kusam.',
    },
    {
      en: "Don't Use Alcohol-Based Products: Alcohol-based products can be harsh and drying, leading to skin dullness.",
      id: 'Jangan Gunakan Produk Berbasis Alkohol: Produk berbasis alkohol bersifat keras dan membuat kulit kering, yang dapat membuat kulitmu kusam.',
    },
    {
      en: "Don't Overload on Products: Using too many products can overwhelm your skin and lead to irritation.",
      id: 'Jangan Berlebihan Menggunakan Produk: Menggunakan produk terlalu banyak bisa membebani kulitmu dan menyebabkan iritasi.',
    },
    {
      en: "Don't Ignore Allergies: Allergic reactions can cause skin irritation and dullness. Identify and avoid allergens.",
      id: 'Jangan Remehkan Alergi: Reaksi alergi bisa menyebabkan iritasi serta kulit kusam. Kenali dan hindari hal-hal yang membuatmu alergi.',
    },
    {
      en: "Don't Stress: High stress levels can negatively impact skin health and contribute to dullness.",
      id: 'Hindari Stres: Tingkat stres yang tinggi bisa berdampak negatif pada kesehatan kulit serta menyebabkan kulit kusam.',
    },
    {
      en: "Don't Forget to Relax: Take time for self-care and relaxation to improve overall well-being and skin radiance.",
      id: 'Jangan Lupa untuk Bersantai: Luangkan waktu buat merawat diri dan bersantai untuk meningkatkan kualitas hidup serta cerahnya kulitmu.',
    },
  ],
};

const ProductRecommendationsPage = () => {
  const {
    lang,
    analysisReport,
    events: { emitAddToCartEvent },
    mode,
  } = useContext(PortContext);

  const navigate = useNavigate();

  const isOffline = mode === 'offlineView';
  const { issues, focusAreas, areasToMaintain, morningRoutine, nightRoutine, other } = analysisReport;
  const [selectedTab, setSelectedTab] = useState('morningRoutine');

  const areas = focusAreas?.length ? focusAreas : areasToMaintain;

  const poolDos = areas.flatMap((area) => dos[area]);
  const poolDonts = areas.flatMap((area) => donts[area]);

  const doText = poolDos[Math.floor(Math.random() * poolDos.length)][lang];
  const dontText = poolDonts[Math.floor(Math.random() * poolDonts.length)][lang];

  return (
    <div className="product-recommentations-page">
      <div className="title-bar">
        <div className="recommendations-title">{content.title[lang]}</div>
        <ImageList
          items={issues.map((issue) => ({
            image: skinIssueImages[issue],
            title: content[issue][lang],
          }))}
        />
        <TabSelector
          tabs={[
            {
              key: 'morningRoutine',
              title: content.morningRoutine[lang],
              image: MorningRoutineImage,
            },
            {
              key: 'nightRoutine',
              title: content.nightRoutine[lang],
              image: NightRoutineImage,
            },
            {
              key: 'other',
              title: content.other[lang],
              image: OtherProductsImage,
            },
          ]}
          selectedTab={selectedTab}
          onTabSelect={(key) => setSelectedTab(key)}
        />
      </div>
      {selectedTab === 'morningRoutine' && (
        <CardGrid
          items={morningRoutine}
          showStepNo
          onAddToCart={emitAddToCartEvent}
          addToCardText={content.addToCart[lang]}
          isOffline={isOffline}
        />
      )}
      {selectedTab === 'nightRoutine' && (
        <CardGrid
          items={nightRoutine}
          showStepNo
          onAddToCart={emitAddToCartEvent}
          addToCardText={content.addToCart[lang]}
          isOffline={isOffline}
        />
      )}
      {selectedTab === 'other' && (
        <CardGrid items={other} onAddToCart={emitAddToCartEvent} addToCardText={content.addToCart[lang]} isOffline />
      )}
      {areas?.length && (
        <Card title={"Do's and Don'ts"} alignTitleLeft>
          <div className="do-dont">
            <img src={DoImage} alt="Do" />
            <div className="text">{doText}</div>
          </div>
          <div className="do-dont">
            <img src={DontImage} alt="Don't" />
            <div className="text">{dontText}</div>
          </div>
        </Card>
      )}
      <Button onClick={() => navigate(-1)} text={content.backToSkinReport[lang]} />
      <br />
      <br />
      <br />
      <br />
    </div>
  );
};

export default ProductRecommendationsPage;
